import React, {useEffect} from "react";
import {RenderableTitle, SurveySectionsRenderingModel} from "data/models/survey/base";
import {Paragraphs_SurveyQuestionPage_Options, TEXT_ALIGNMENT_CLASS} from "data/models/survey/paragraphs";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {DESCRIPTION_CLASS, QUESTION_CONTAINER_CLASS} from "components/Survey/classes";
import ParagraphPageComponent from "./ParagraphPageComponent";

export type Paragraphs_SurveyQuestionPage_Props = {
  options: Paragraphs_SurveyQuestionPage_Options,
  visible: boolean,
  questionId: string,
  required: boolean,
  title: RenderableTitle,
  description: RenderableTitle | null,
  surveySectionsRenderingModel: SurveySectionsRenderingModel | null,
  value: "visited" | undefined,
  onChange: (id: string, value: "visited") => void,
}

export default function ParagraphsSurveyQuestionPage(
    {
      options,
      visible,
      questionId,
      title,
      description,
      surveySectionsRenderingModel,
      value,
      onChange
    }: Paragraphs_SurveyQuestionPage_Props
) {
  useEffect(() => {
    if (visible && isNullOrUndefined(value)) {
      onChange(questionId, "visited");
    }
  }, [visible, value, onChange, questionId]); // Empty dependency array ensures it only loads on mount

  if (isNullOrUndefined(surveySectionsRenderingModel)) {
    return <></>;
  }

  return <div className={"flex flex-col w-full"}>
    <div className={QUESTION_CONTAINER_CLASS}>
      <div className={"my-4 text-center"}>{title}</div>
      {description !== null && <div className={"my-4 text-center"}>{description}</div>}
      <div className={TEXT_ALIGNMENT_CLASS[options.textAlignment]}>
      {options.paragraphs.map((paragraph, index) =>
          <ParagraphPageComponent
              key={index}
              title={paragraph}
              surveySectionRenderingModel={surveySectionsRenderingModel}
              defaultTitleClass={DESCRIPTION_CLASS}
          />
      )}
      </div>
    </div>
  </div>

}
